export enum TrafficRequestInputTypeEnum {
  RECOMMENDATIONS = "recommendation",
  NEW_TERMS = "newTerms",
  GROWTH_TERMS = "growthTerms"
}